import React, { useState, useEffect } from 'react'

const NumberWithButtons = (props) => {
  const { 
    min = 0, 
    max = 1000, 
    step = 1, 
    initial = 0, 
    onChange : updateParent } = props;

  const [number, setNumber] = useState(initial);

  useEffect(() => {
    updateParent(number);
  }, [number, updateParent]);

  const onPlus  = () => {
    let _number = number;
    if (_number + step <= max) {
      setNumber(_number + step)
    }
  }

  const onMinus = () => {
    let _number = number;
    if (_number - step >= min) {
      setNumber(_number - step)
    }
  }

  const changeNumber = (e) => {
    if (!isNaN(e.target.value)) {
      let value = parseInt(e.target.value);
      if (value >= min && value <= max) {
        setNumber(value);
      } else {
        e.target.value = number;
      }
    } else {
      e.target.value = number;
    }
  }

  return (
    <div className='min-w-[6.5rem]'>
      <button className='w-6 border border-r-0 border-gray-300 rounded-l' 
        onClick={onMinus}>-</button>
      <input type='number' onChange={changeNumber} 
        className='w-14 border border-gray-300 px-2 text-center number-with-buttons' 
        value={number} />
      <button className='w-6 border border-l-0 border-gray-300 rounded-r' 
        onClick={onPlus}>+</button>
    </div>
  )
}

export default NumberWithButtons;